import { TMNotificationPriority, TMNotificationSystem } from "../../../notification-system";
import { NotificationModelFactory } from "../../../notification-system/models/notification-model-factory";
import { AddNotificationActionPayload, NotificationSliceState, NotificationState } from "./types";

const deliverNotification = (notification: NotificationState) => {
  const notificationModel = NotificationModelFactory.create({
    id: notification.id,
    type: notification.type,
    title: notification.title,
    message: notification.message,
    priority: notification.priority || TMNotificationPriority.NORMAL,
    data: notification.data,
  });

  if (!notificationModel) return;
  TMNotificationSystem.instance.enqueueNotification(notificationModel);
}

export const addNotification = (state: NotificationSliceState, payload: AddNotificationActionPayload): NotificationSliceState => {
  let read = payload.read ?? false;
  let delivered = payload.delivered ?? false;
  let incrementUnreadCount = !read;

  const notificationIndex = state.pendingNotifications.findIndex((notification) => notification.id === payload.id);
  if (notificationIndex >= 0) {
    const localNotificationData = state.pendingNotifications[notificationIndex];
    if (!localNotificationData.delivered && !delivered) {
      deliverNotification(payload);
    }

    if (localNotificationData.delivered && !delivered) {
      delivered = true;
    }

    if (!localNotificationData.read && !read) {
      incrementUnreadCount = false;
    }

    state.pendingNotifications.splice(notificationIndex, 1);
  }

  if (notificationIndex < 0 && !delivered) {
    deliverNotification(payload);
  }

  state.pendingNotifications = [...state.pendingNotifications, {
    id: payload.id,
    type: payload.type,
    priority: payload.priority,
    createdAt: payload.createdAt,
    title: payload.title,
    message: payload.message,
    data: payload.data,
    read,
    delivered,
  }];
  state.unreadCount = incrementUnreadCount ? state.unreadCount + 1 : state.unreadCount;

  return state;
}
